import Vue from 'vue'
import api from '@/services/api'
import unionBy from 'lodash/unionBy'

export default {

  namespaced: true,

  state: {
    landings: {},
    inners: {},
    projects: {
      items: [],
      count: 0
    },
    news: {
      items: [],
      count: 0
    },
    loading: false
  },

  getters: {
    all: state => type => state[type].items,
    primary: state => type => state[type].items.length > 0 ? state[type].items[0] : null,
    items: state => type => state[type].items.filter((item, index) => index > 0),
    count: state => type => state[type].count,
    loading: state => state.loading
  },

  mutations: {
    setLanding (state, { name, data }) {
      state.landings[name] = data
    },

    updateList (state, { name, items, firstLoad }) {
      const list = state[name];
      let newItems = unionBy(list.items, items, 'url');

      if(firstLoad){
        newItems = items;
      }
      else{
        newItems = unionBy(list.items, items, 'url');
      }

      Vue.set(state[name], 'items', newItems);
      Vue.set(state[name], 'count', items.length);
    },

    setInner (state, { name, data }) {
      state.inners[name] = data
    },

    startLoading (state) {
      state.loading = true
    },

    endLoading (state) {
      state.loading = false
    }
  },

  actions: {
    async fetchLanding ({ commit }, name) {
      const response = await api.pages.get(name)
      const data = response.data

      commit('setLanding', { name, data })
      return data
    },

    async fetchDynamic ({ state, commit }, { name, limit = null, offset, firstLoad }) {
      commit('startLoading');

      const itemsResponse = await api.pages.getByType(name, limit, offset);
      const items = itemsResponse.data;

      commit('updateList', { name, items, firstLoad });
      commit('endLoading');

      return items
    },

    async fetchInner ({ commit }, { url, name }) {

      let response = await api.pages.getDefault(url, name);


      if (response === undefined){
        response = {data:{status:404}};
      }

      const data = response.data;

      commit('setInner', { name, data });

      return data
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/pages.js